import { ReactElement, useState } from "react";
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import { Stepper, Step, StepLabel, StepContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

// components
import { BannerSection } from "./components/Banner_DataAnalysis";
import ImgWorkProcess from "@imgs/img-work-process.jpg";

const steps = [
  {
    label: '事業目的の確認',
    description: `現状の問題点や課題をヒアリング`,
  },
  {
    label: 'データの概要把握',
    description:
      'データの種別や形式を確認',
  },
  {
    label: '分析方針の方向付け',
    description: `スケジュールとアウトプットの確認`,
  },
  {
    label: '前処理・特徴量作成',
    description: `欠損・ノイズ・エラー値などの処理、タスクに適した特徴量の作成`,
  },
  {
    label: 'モデル選択',
    description: `目的に適した手法の選択`,
  },
  {
    label: '分析の実施・評価',
    description: `分析の結果から評価・考察を行う`,
  },
];

const SvcAlgorithmPage = (): ReactElement => {
  return (
    <>
      <BannerSection />
      <Container sx={{ my: 1, p: 5, maxWidth: "1170px", }}>
        <Grid container spacing={2} sx={{ mx: 'auto', justifyContent: "center", maxWidth: '860px', minHeight: '500px' }}>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '32px', fontWeight: 800, color: '#3F51B5', }}>分析の流れ</Typography>
          </Grid>
          <Grid sm={6} xs={12}>
            <Stepper activeStep={steps.length} orientation="vertical">
              {steps.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel
                    optional={
                      <Typography sx={{ ml: 2, mt: 1, fontSize: '16px', color: '#303030' }}>{step.description}</Typography>
                    }
                  >
                    <Typography sx={{ ml: 2, fontSize: '22px', }}>{step.label}</Typography>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box
              component="img"
              src={ImgWorkProcess}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default SvcAlgorithmPage;
